<template>
    <DsSingleSelect
        v-model="selectedWireDoc"
        :id
        :disabled
        :error
        label="Wire instructions"
        :options="wireDocOptions"
        placeholder="Select wire instructions"
        required
        @optionSelected="$emit('optionSelected')"
    >
        <template #emptyState>
            <DsSelectEmptyState
                icon="fa-regular fa-file-invoice-dollar"
                subtitle="Once added, all wire instructions will be listed here."
                title="No wire instructions yet"
            />
        </template>
    </DsSingleSelect>
</template>

<script setup lang="ts">
import DsSelectEmptyState from '@/components/design-system/DsSelectEmptyState.vue';
import DsSingleSelect from '@/components/design-system/singleselect/DsSingleSelect.vue';
import type { AvailableWireDoc, DsSingleSelectAvailableWireDocOption } from '@/components/Views/Company/File/file.types';
import { buildWireDocOptions } from '@/components/Views/Company/shared/wire-instructions-utils';
import { useUserStore } from '@/stores/company/user.store';
import type { Branch } from '@/types/closinglock.types';
import { computed, useId, watch } from 'vue';

interface SelectWireInstructionsProps {
    branchId?: Branch['id'];
    disabled?: boolean;
    error?: string;
}

const props = defineProps<SelectWireInstructionsProps>();

defineEmits<{
    optionSelected: [];
}>();

const userStore = useUserStore();

const id = useId();

const selectedWireDoc = defineModel<AvailableWireDoc>('wireDoc');

const handleWireDocOptionsChange = (options: DsSingleSelectAvailableWireDocOption[]) => {
    const defaultMatch = options.find(option => option.id === userStore.defaultWireDoc?.id);
    const soleOption = options.length === 1 ? options[0] : undefined;
    selectedWireDoc.value = defaultMatch ?? soleOption;
};

const wireDocOptions = computed<DsSingleSelectAvailableWireDocOption[]>(() =>
    buildWireDocOptions(userStore.availableWireDocs, props.branchId, userStore.defaultWireDoc?.id),
);

watch(wireDocOptions, handleWireDocOptionsChange, { immediate: true });
</script>
